/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingTaxAmountDto } from './traveline-booking-tax-amount-dto';
import {
    TravelineBookingTaxAmountDtoFromJSON,
    TravelineBookingTaxAmountDtoFromJSONTyped,
    TravelineBookingTaxAmountDtoToJSON,
    TravelineBookingTaxAmountDtoToJSONTyped,
} from './traveline-booking-tax-amount-dto';

/**
 * Total for entire service
 * @export
 * @interface TravelineServiceTotalDto
 */
export interface TravelineServiceTotalDto {
    /**
     * Price excluding taxes and fees payable at check-in
     * @type {number}
     * @memberof TravelineServiceTotalDto
     */
    priceBeforeTax: number;
    /**
     * Amount of taxes and fees payable at check-in
     * @type {number}
     * @memberof TravelineServiceTotalDto
     */
    taxAmount: number;
    /**
     * Taxes and fees payable at check-in
     * @type {Array<TravelineBookingTaxAmountDto>}
     * @memberof TravelineServiceTotalDto
     */
    taxes?: Array<TravelineBookingTaxAmountDto> | null;
}

/**
 * Check if a given object implements the TravelineServiceTotalDto interface.
 */
export function instanceOfTravelineServiceTotalDto(value: object): value is TravelineServiceTotalDto {
    if (!('priceBeforeTax' in value) || value['priceBeforeTax'] === undefined) return false;
    if (!('taxAmount' in value) || value['taxAmount'] === undefined) return false;
    return true;
}

export function TravelineServiceTotalDtoFromJSON(json: any): TravelineServiceTotalDto {
    return TravelineServiceTotalDtoFromJSONTyped(json, false);
}

export function TravelineServiceTotalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineServiceTotalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'priceBeforeTax': json['priceBeforeTax'],
        'taxAmount': json['taxAmount'],
        'taxes': json['taxes'] == null ? undefined : ((json['taxes'] as Array<any>).map(TravelineBookingTaxAmountDtoFromJSON)),
    };
}

  export function TravelineServiceTotalDtoToJSON(json: any): TravelineServiceTotalDto {
      return TravelineServiceTotalDtoToJSONTyped(json, false);
  }

  export function TravelineServiceTotalDtoToJSONTyped(value?: TravelineServiceTotalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceBeforeTax': value['priceBeforeTax'],
        'taxAmount': value['taxAmount'],
        'taxes': value['taxes'] == null ? undefined : ((value['taxes'] as Array<any>).map(TravelineBookingTaxAmountDtoToJSON)),
    };
}

